<router-outlet>
  <!-- The header for the application -->
  <app-header></app-header>
  <!-- The user input to search for a word -->
  <app-dictionary-input></app-dictionary-input>
</router-outlet>